import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-facs-tour',
  templateUrl: './facs-tour.component.html',
  styleUrls: ['./facs-tour.component.scss']
})
export class FacsTourComponent implements OnInit {

  public paramsRouter = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    ) { }

  firstText = `A busca ajudará você a encontrar clientes com facilidade. Você poderá usar os seguintes critérios:
   <strong>nome do cliente</strong>, <strong>produto</strong>, <strong>e-mail</strong> ou <strong>telefone</strong>.`;
  secondText = `Ao digitar um termo na busca, uma lista de sugestões aparecerá.
  <br><br> Clique em <strong><i>Novo Estilo</i></strong> para buscar esse termo.`;
  thirdText = 'Ao selecionar itens de busca uma tag será adicionada e trará todos os resultados contendo aquele termo.';
  fourthText = 'Você poderá combinar várias tags ao mesmo tempo.';
  fifthText = `Você também poderá apenas digitar um termo e apertar <strong><i>Enter</i></strong>,
   dessa forma traremos para você resultados gerais contendo aquele termo.`;
  step = window.localStorage.getItem('facs-tour-step') ? parseInt(window.localStorage.getItem('facs-tour-step'), 10) : 0;
  autocompleteOptions = [];
  auto: FormControl;
  tags = [];
  totalSteps = 5;
  form = FormGroup;
  facsList = [
    {
      title: 'Sem Atendimento', facs: [
        { badges: [],
          color: 1,
          email: 'joao@bol.com',
          funnel_stage: {value: 'Sem Atendimento', sub_items: []},
          id: '01278696-0000-0000-0000-000000000000',
          last_update_date: '2020-08-12T19:52:24.347Z',
          name: 'João Carlos Ribeiro da Silva',
          phone: {ddi: '+55', phone: '11 93609 5941'},
          product: 'One Park Perdizes',
          stage_update_date: '2020-06-15T21:57:03.737Z',
          user_full_name: 'João Carlos Ribeiro da Silva',
          user_nickname: 'CAMPERS'
        }
      ]
    },
    {title: 'Sem Contato', facs: [
      { badges: [],
        color: 1,
        email: 'fsilva@gmail.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2018-08-12T19:52:24.347Z',
        name: 'Fabrício da Silva',
        is_favorite: true,
        phone: {ddi: '+55', phone: '11 91426 7653'},
        product: 'Central Park Pinheiros',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Fabrício da Silva',
        user_nickname: 'FSILVA'
      },
      { badges: [],
        color: 2,
        email: 'marcia@hotmail.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2019-12-22T19:52:24.347Z',
        name: 'Márcia Ferreira Pedrosa',
        phone: {ddi: '+55', phone: '11 94409 3141'},
        product: 'Golden Gates Morumbi',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Márcia Ferreira Pedrosa',
        user_nickname: 'MARCINHA'
      }
    ]},
    {title: 'Em Atendimento', facs: [
      { badges: [],
        color: 1,
        email: 'cabral@outlook.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Bruce Cabral',
        phone: {ddi: '+55', phone: '11 93239 5541'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Bruce Cabral',
        user_nickname: 'HULK'
      },
      { badges: [],
        color: 3,
        email: 'terezasilva@gmail.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Tereza Carla Silva',
        phone: {ddi: '+55', phone: '11 93609 5941'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Tereza Carla Silva',
        user_nickname: 'Terezinha'
      }
    ]},
    {title: 'Visita', facs: [
      { badges: [],
        color: 1,
        email: 'anafarias@ig.com.br',
        funnel_stage: {value: 'Visita', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Ana Farias',
        phone: {ddi: '+55', phone: '11 93609 5941'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Ana Farias de Castro Alves',
        user_nickname: 'CAMPERS'
      },
      { badges: [],
        color: 1,
        email: 'teste17f941@mailinator.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'ESD 1 - 5E 15/06 17:55 "One Park Perdizes"',
        phone: {ddi: '+55', phone: '11 93609 5941'},
        product: 'One Park Perdizes',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'João Carlos Ribeiro da Silva',
        user_nickname: 'CAMPERS'
      }
    ]},
    {title: 'Proposta', facs: []},
    {title: 'Venda', facs: []}
  ];

  facsFilter1 = [
    {title: 'Sem Atendimento', facs: []},
    {title: 'Sem Contato', facs: []},
    {title: 'Em Atendimento', facs: [
      { badges: [],
        color: 1,
        email: 'cabral@outlook.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Bruce Cabral',
        phone: {ddi: '+55', phone: '11 93239 5541'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Bruce Cabral',
        user_nickname: 'HULK'
      },
      { badges: [],
        color: 3,
        email: 'terezasilva@gmail.com',
        funnel_stage: {value: 'Sem Atendimento', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Tereza Carla Silva',
        phone: {ddi: '+55', phone: '11 93609 5941'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Tereza Carla Silva',
        user_nickname: 'Terezinha'
      }
    ]},
    {title: 'Visita', facs: [
      { badges: [],
        color: 1,
        email: 'anafarias@ig.com.br',
        funnel_stage: {value: 'Visita', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Ana Farias',
        phone: {ddi: '+55', phone: '11 93609 5941'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Ana Farias de Castro Alves',
        user_nickname: 'CAMPERS'
      }
    ]},
    {title: 'Proposta', facs: []},
    {title: 'Venda', facs: []}
  ];

  facsFilter2 = [
    {title: 'Sem Atendimento', facs: []},
    {title: 'Sem Contato', facs: []},
    {title: 'Em Atendimento', facs: []},
    {title: 'Visita', facs: [
      { badges: [],
        color: 1,
        email: 'anafarias@ig.com.br',
        funnel_stage: {value: 'Visita', sub_items: []},
        id: '01278696-0000-0000-0000-000000000000',
        last_update_date: '2020-08-12T19:52:24.347Z',
        name: 'Ana Farias',
        phone: {ddi: '+55', phone: '11 93609 5941'},
        product: 'Novo Estilo',
        stage_update_date: '2020-06-15T21:57:03.737Z',
        user_full_name: 'Ana Farias de Castro Alves',
        user_nickname: 'CAMPERS'
      }
    ]},
    {title: 'Proposta', facs: []},
    {title: 'Venda', facs: []}
  ];
  body = document.getElementsByTagName('body')[0];

  ngOnInit(): void {
    this.route.queryParams.subscribe(x => {
      if(x != null){
        this.paramsRouter= {
          user_type: x.user_type ? x.user_type: null,
          user_id: x.user_id ? x.user_id : null,
          user_nickname: x.user_nickname ? x.user_nickname : null,
          user_name: x.user_name ? x.user_name : null,
        }
      }
    });
    this.auto = new FormControl('');
    if (this.step > 6) {
      this.step = 0;
      this.body.style.setProperty('overflow', 'hidden');
      return;
    }
    this.step --;
    this.nextStep(2);
  }

  nextStep(event) {
    switch (this.step) {
      case 0: {
        this.body.style.setProperty('overflow', 'auto');
        this.stepGeneralState();
        break;
      }
      case 1: {
        this.step1State();
        this.stepGeneralState();
        break;
      }
      case 2: {
        if (event === 2) {
          this.step2State();
          this.stepGeneralState();
        }
        break;
      }
      case 3 : {
        this.step3State();
        this.stepGeneralState();
        break;
      }
      case 4 : {
        this.step4State();
        this.stepGeneralState();
        break;
      }
      case 5 : {
        this.stepGeneralState();
        this.body.style.setProperty('overflow', 'hidden');
        break;
      }
      case 6 : {
        this.stepGeneralState();
        this.skipTour();
        break;
      }
      default: {
        this.stepGeneralState();
        break;
      }
    }
  }

  step1State() {
    this.auto.setValue('Novo');
    this.autocompleteOptions = [
      {name: 'AP <strong>Novo</strong> conceito', type: 'Cliente'},
      {name: 'Empreendimento <strong>Novo</strong> Mundo', type: 'Produto'},
      {name: '<strong>Novo</strong> Estilo', type: 'Produto'},
      {name: 'Empreendimento <strong>Novo</strong> Conceito', type: 'Produto'}];
    this.body.style.setProperty('overflow', 'auto');
  }

  step2State() {
    this.tags = [{type: 'Produto', description: 'Novo Estilo'}];
    this.facsList = this.facsFilter1;
  }

  step3State() {
    this.tags = [{type: 'Produto', description: 'Novo Estilo'}, {type: 'Cliente', description: 'Ana Farias'}];
    this.facsList = this.facsFilter2;
  }

  step4State() {
    this.auto.setValue('');
  }

  stepGeneralState() {
    this.step = this.step + 1;
    this.saveTourStep();
  }

  saveTourStep() {
    window.localStorage.setItem('facs-tour-step', this.step.toString());
  }

  skipTour() {
    window.localStorage.setItem('facs-tour-step', '7');
    window.localStorage.setItem('facs-tour-complete', 'true');
    this.body.style.setProperty('overflow', 'auto');
    if (this.router.url.includes('helper=true')) {
      this.router.navigate(['/central-ajuda']);
    } else {
      this.paramsRouter.user_id != null ? 
      this.router.navigate([`/facs`],
      { queryParams: 
        { user_id: this.paramsRouter.user_id,
          user_type: this.paramsRouter.user_type,
          user_nickname: this.paramsRouter.user_nickname,
          user_name: this.paramsRouter.user_name 
        }
      }) :
      this.router.navigate(['/facs']);
    }
  }
}
